import React from 'react';

import Actions from './Actions';

const columns = (refresh) => [
  {
    name: 'Message',
    selector: (row) => row.attributes.message,
    sortable: true,
  },
  {
    name: 'Action',
    sortable: false,
    width: '100px',
    cell: (row) => <Actions row={row} refresh={refresh} />,
  },
];

export default columns;
